<template>
  <div class="row mb-5 mt-5">
    <div class="col-md-12 mb-4">
      <div class="fw-500 text-black mb-0 s-24">
        Campaign Performance Metrics
      </div>
    </div>
    <!-- Total Giving -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary bg-gray-200 border-gray-100 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Total Donations</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <div class="s-20 text-black">
            <span>NGN</span>
            <span class="fw-500">55,278,000</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Average Gift -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary border-gray-100 bg-gray-200 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Participants/Donor</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <h3 class="card-title fw-500">4,352</h3>
        </div>
      </div>
    </div>

    <!-- Most Project Funded -->
    <div class="col-md-4 col-sm-6 col-12 mb-3">
      <div
        class="card card-summary border-gray-100 bg-gray-200 h-100 pb-1 px-3 pt-3"
      >
        <div
          class="card-icon d-flex justify-content-between mb-2 mt-1 align-items-center"
        >
          <span class="card-text">Total Impression</span>
        </div>
        <div class="card-content text-right mb-1 mt-5">
          <h3 class="card-title fw-500">3,507</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mb-4">
      <div class="card border- shadow-sm h-100">
        <div class="card-body">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap mb-4"
          >
            <div class="d-flex align-items-center">
              <div><PiggyBank class="w-14 h-14" /></div>
              <div class="mb-0 s-20 text-dak fw-500">
                Campaign Donation Trend
              </div>
            </div>
            <div class="d-flex align-items-center gap-3">
              <div class="py-2 pl-4 primary--text s-15 bg-gray-500 fw-500">
                <el-dropdown trigger="click" class="w-100">
                  <span class="el-dropdown-link w-100">
                    <div
                      class="d-flex justify-content-between primary--text w-100"
                      size="large"
                    >
                      <span class="my-2"
                        >Sort By
                        {{ sortBy && sortBy.name ? sortBy.name : sortBy }}</span
                      >
                      <div class="bg-white d-flex py-1 my-1">
                        <el-icon class="el-icon--right">
                          <arrow-down />
                        </el-icon>
                      </div>
                    </div>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        v-for="(itm, indx) in chartItemdropdown"
                        :key="indx"
                        @click="selectedType(itm)"
                        >{{ itm.name }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
          </div>

          <!-- Chart Placeholder -->
          <div
            class="chart-container"
            style="height: 300px; position: relative"
          >
            <TrendAreaChart :data="campaignData" :categories="monthLabels" />
          </div>

          <div class="mt-3">
            <small class="primary--text">
              <i class="fas fa-circle mr-1"></i>
              Campaign Donation Trend
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mt-5">
    <TableNoExport2
      :data="filteredDonorData"
      :headers="donorHeaders"
      :textHead="textHead"
      @update:searchText="handleSearchTextUpdate"
      :checkMultipleItem="false"
      :filterItem="false"
      @checkedrow="handleSelectionChange"
    >
      <template v-slot:name="{ item }">
        <div class="c-pointer fw-400 s-14">{{ item.name }}</div>
      </template>

      <template v-slot:date="{ item }">
        <div class="c-pointer fw-400 s-14">
          {{ item.date }}
        </div>
      </template>
      <template v-slot:amount="{ item }">
        <div class="c-pointer font-weight-600 s-14" style="color: #1C6C04;">
          N{{ item.amount.toLocaleString() || "" }}
        </div>
      </template>
      <template v-slot:action="{ item }">
        <el-dropdown trigger="click">
          <el-icon><MoreFilled /></el-icon>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <div class="text-color" @click="deleteDonation(item.id, index)">
                  Delete
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </TableNoExport2>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import TrendAreaChart from "../../../../components/charts/TrendAreaChart.vue";
import PiggyBank from "../../../../components/icons/PiggyBankIcon.vue";
import TableNoExport2 from "@/components/table/TableNoExport2";

const campaignData = ref([200, 300, 400, 500, 450, 600, 550, 700, 800]);
const sortBy = ref("month");
const textHead = ref("All Donation");
const searchText = ref("");
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};

const monthLabels = ref([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
]);
const donorHeaders = ref([
  { name: "Name", value: "name" },
  { name: "Date", value: "date" },
  { name: "Amount", value: "amount" },
]);
const donorData = ref([
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 4000,
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
  },
]);
const filteredDonorData = computed(() => {
  if (!searchText.value) return donorData.value;
  return donorData.value.filter((d) =>
    Object.values(d).some((val) =>
      String(val).toLowerCase().includes(searchText.value.toLowerCase())
    )
  );
});

const chartItemdropdown = ref([
  { name: "Month", id: 1 },
  { name: "Week", id: 2 },
]);
const selectedType = (item) => {
  sortBy.value = item;
};
</script>
<style scoped>
.card-summary {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}
.card {
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
}
.card-title {
  font-size: 25px !important;
  margin: 0;
  color: #000000;
}
.card-text {
  margin: 0;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #111111 !important;
}
.chart-container {
  background: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
  height: 100%;
}
</style>
